
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lien-he",
      function () {
        return require("private-next-pages/lien-he/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lien-he"])
      });
    }
  